$(document).ready(function() {

    // MENU

    $(document).on('click', '.js-menu-toggle', function (e) {
        e.preventDefault();
        $(this).toggleClass('c-header__hamburger--active');
        $('.js-main-menu').toggleClass('c-header__main-menu-container--active');

        if ($(this).hasClass('c-header__hamburger--active')) {
            $('body').addClass('u-no-scroll');
        } else {
            $('body').removeClass('u-no-scroll');
        }
    });

    // SUBNAV

    $(document).on('click', '#menu-user-menu li:last-child a', function(){
        $('body').removeClass('u-no-scroll');
        $(this).removeClass('js-menu-toggle');
        $('.js-main-menu').removeClass('c-header__main-menu-container--active');
    })

    $('.js-main-menu .sub-menu').each(function () {
        $('<div class="c-header__main-menu-toggle-sub js-toggle-sub"></div>').insertBefore($(this));
    });

    $(document).on('click', '.js-toggle-sub', function () {
        $(this).toggleClass('c-header__main-menu-toggle-sub--active');
        $(this).next('.sub-menu').toggleClass('sub-menu--active');
    });

    $('.js-menu-1-text').appendTo('#menu-main-menu li:nth-child(1) .sub-menu li:nth-child(1) a');
    $('.js-menu-2-text').appendTo('#menu-main-menu li:nth-child(1) .sub-menu li:nth-child(2) a');
    $('.js-menu-3-text').appendTo('#menu-main-menu li:nth-child(1) .sub-menu li:nth-child(3) a');
    $('#menu-main-menu li:nth-child(1) .sub-menu li:nth-child(4), #menu-main-menu li:nth-child(1) .sub-menu li:nth-child(5)').wrapAll('<li class="sub-menu-last-item"><ul class="js-menu-other"></ul></li>');
    $('.js-menu-other-text').insertBefore('.js-menu-other');
    $('.js-menu-4-text').appendTo('.js-menu-other li:nth-child(1)');
    $('.js-menu-5-text').appendTo('.js-menu-other li:nth-child(2)');

    // SCROLL LINK BEHAVIOUR

    $(document).on('click', '.js-scroll-link', function (e) {
        e.preventDefault();
        var target = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(target).offset().top - 50
        }, 500);
    });

    // SOLUTIONS ACCORDION

    $(document).on('click', '.js-solutions-switch', function(e){
        e.preventDefault();
        $('.js-solutions-item').removeClass('c-solutions__item--active');
        $('.js-solutions-switch').not(this).removeClass('c-solutions__item-title--active');
        if(!$(this).hasClass('c-solutions__item-title--active')) {
            $(this).parents('.js-solutions-item').addClass('c-solutions__item--active');
            $(this).addClass('c-solutions__item-title--active');
        }
        else {
            $(this).removeClass('c-solutions__item-title--active');
        }
    });

    // BLOG

    if($('.js-blog-title').length) {
        $('.js-title').html($('.js-blog-title').text());
        if($('.js-title').html().length == 0) {
            $('.js-title').text('Blog');
        }
    }

    if($('.js-taxonomy-description').length === 0) {
        $('.js-blog-subheader').show();
    }

    $('.js-title').addClass('c-header__title--visible');

    // SLICK

    var slider = $('.js-references-slider');
    slider.slick({
        centerMode: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: true,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                }
            }
        ]
    });

    var clientsSlider = $('.js-clients-slider');
    clientsSlider.slick({
        centerMode: false,
        slidesToShow: 6,
        slidesToScroll: 2,
        dots: false,
        arrows: true,
        infinite: true,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    centerMode: false,
                    slidesToScroll: 1
                }
            },{
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    slidesToScroll: 1
                }
            }
        ]
    });

    // USPs

    $('.js-usps-item').each(function(i){
        $(this).attr('data-id', i);
        $(this).addClass('js-usps-' + i);

        $(this).find('.js-usps-nav').prepend($('<div class="c-usps__nav-item c-usps__nav-item--next js-usps-nav-item" data-id="' + (i+1) + '"></div>'));
        $(this).find('.js-usps-nav').prepend($('<div class="c-usps__nav-item c-usps__nav-item--prev js-usps-nav-item" data-id="' + (i-1) + '"></div>'));
    });


    $('.js-usps-menu-item').each(function(i){
        $(this).attr('data-id', i);
        $(this).addClass('js-usps-menu-item-' + i);
    });

    $(document).on('click', '.js-usps-nav-item, .js-usps-menu-item ', function(){
        var id = parseInt($(this).attr('data-id'));
        var numberOfItems = parseInt($('.js-usps-item').length);

        if(id < 0) {
            id = numberOfItems - 1;
        }

        else if(id >= numberOfItems) {
            id = 0;
        }

        $('.js-usps-menu-item').removeClass('c-usps__menu-item--active');
        $('.js-usps-menu-item-' + id).addClass('c-usps__menu-item--active');
        $('.js-usps-item').hide();
        $('.js-usps-' + id).fadeIn();

        if (window.matchMedia('(max-width: 800px)').matches) {
            document.getElementsByClassName('c-usps__menu-item--active')[0].scrollIntoView();
        }
    });

    // CLOUD

    (function () {

        if(document.getElementById("js-cloud-container")) {
            var id = 0;
            var numberOfItems = parseInt($('.js-cloud-item').length);

            $('.js-cloud-item').each(function (i) {
                $(this).attr('data-id', i);
                $(this).addClass('js-cloud-' + i);

                $(this).find('.js-cloud-nav').prepend($('<div class="c-cloud__nav-item c-cloud__nav-item--next js-cloud-nav-item" data-id="' + (i + 1) + '"></div>'));
                $(this).find('.js-cloud-nav').prepend($('<div class="c-cloud__nav-item c-cloud__nav-item--prev js-cloud-nav-item" data-id="' + (i - 1) + '"></div>'));
            });

            $(document).on('click', '.js-cloud-nav-item', function () {
                id = parseInt($(this).attr('data-id'));
                $('.js-cloud-item').hide();
                $('.js-cloud-' + id).fadeIn();
                document.getElementsByClassName('c-cloud__title')[0].scrollIntoView();
            });

            document.getElementById("js-cloud-container").addEventListener('touchstart', handleTouchStart, false);
            document.getElementById("js-cloud-container").addEventListener('touchmove', handleTouchMove, false);

            var xDown = null;
            var yDown = null;

            function getTouches(evt) {
                return evt.touches ||             // browser API
                    evt.originalEvent.touches; // jQuery
            }

            function handleTouchStart(evt) {
                const firstTouch = getTouches(evt)[0];
                xDown = firstTouch.clientX;
                yDown = firstTouch.clientY;
            };

            function handleTouchMove(evt) {
                if (!xDown || !yDown) {
                    return;
                }

                var xUp = evt.touches[0].clientX;
                var yUp = evt.touches[0].clientY;

                var xDiff = xDown - xUp;
                var yDiff = yDown - yUp;

                if (Math.abs(xDiff) > Math.abs(yDiff)) {/*most significant*/
                    if (xDiff > 0) {
                        id++;
                        if (id >= numberOfItems) {
                            id = numberOfItems - 1;
                        } else {
                            $('.js-cloud-item').hide();
                            $('.js-cloud-' + id).fadeIn();
                        }

                    } else {
                        id--;
                        if (id < 0) {
                            id = 0;
                        } else {
                            $('.js-cloud-item').hide();
                            $('.js-cloud-' + id).fadeIn();
                        }
                    }
                }
                /* reset values */
                xDown = null;
                yDown = null;
            };
        }
    })();

    // BLOG

    if($('.c-blog__menu-item--active').length == 0) {
        $('.js-all-blog-item').addClass('c-blog__menu-item--active');
    }

    $('.js-blog-category ul li').each(function(){
        if($(this).html().includes('Mzdy')) {
            $(this).addClass('yellow');
        }
        else if($(this).html().includes('Účetnictví')) {
            $(this).addClass('blue');
        }
        else if($(this).html().includes('Legislativa')) {
            $(this).addClass('orange');
        }
    });

    // JOBS LIST

    (function () {
        function initSlick() {
            var teamSlider = $('.js-team-slider');
            teamSlider.slick({
                centerMode: false,
                slidesToShow: 4,
                slidesToScroll: 2,
                dots: true,
                arrows: true,
                infinite: true,

                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            centerMode: false,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 500,
                        settings: {
                            slidesToShow: 1,
                            centerMode: false,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }


        //const url = new URL('http://localhost/econs/team-list'); // needs to change for dev / production env
        const url = new URL('https://www.e-cons.cz/team-list')
        var filteredURL = url;

        function getTeam(filteredURL) {

            $.post(filteredURL,
                function (data) {
                    var content = $('.js-team-content');
                    content.html(data);
                    initSlick();
                    $('.slick-dots').wrap('<div class="slick-nav-container"></div>');
                }
            );
        }

        initSlick();
        setTimeout(function(){
            $('.slick-dots').wrap('<div class="slick-nav-container"></div>');
        }, 200);


        getTeam(filteredURL);

        $(document).on('click', '.js-team-menu-item', function(e){
            e.preventDefault();
            filteredURL = url + '?department=' + $(this).attr('data-id');
            getTeam(filteredURL);
            $('.js-team-menu-item').removeClass('c-team__menu-item--active');
            $(this).addClass('c-team__menu-item--active');
        });
    })();

    // FORM

    if($('.js-job-position').length) {
        $('.js-job-position input').val($('.js-title').text());
    }

    $('.js-form-input-7, .js-service-1, .js-service-2').hide();

    $(document).on('change', '.js-form-input-6 input', function(){
        if($('.js-form-input-6 .wpcf7-list-item.last input').is(':checked')) {
            $('.js-form-input-7').show();
        }
        else {
            $('.js-form-input-7').hide();
        }
    });

    $(document).on('change', '.js-radio-container input', function(){
        if($('#service-1').is(':checked')) {
            $('.js-service-1').show();
            $('.js-service-2').hide();
            var text = $('#service-1 + label span').html().replace('<br>', ' ');
            $('.js-form-service input').val(text);
        }
        else if($('#service-2').is(':checked')) {
            $('.js-service-2').show();
            $('.js-service-1').hide();
            var text = $('#service-2 + label span').html().replace('<br>',' ');
            $('.js-form-service input').val(text);
        }
        else {
            $('.js-service-1, .js-service-2').show();
            var text = $('#service-3 + label span').html().replace('<br>',' ');
            $('.js-form-service input').val(text);
        }
    });

    $(document).on('change', '.js-form-input-1 input, .js-form-input-2 input, .js-form-input-3 input, .js-form-input-4 input, .js-form-input-5 input, .js-form-input-6 input, .js-form-input-7 textarea', function(){
        $('.js-form-review-1').html($('.js-form-input-1 input').val());
        $('.js-form-review-2').html($('.js-form-input-2 input').val());
        $('.js-form-review-3').html($('.js-form-input-3 input').val());
        $('.js-form-review-4').html($('.js-form-input-4 input').val());
        $('.js-form-review-5').html($('.js-form-input-5 input').val());
        $('.js-form-review-6').html($('.js-form-input-6 input:checked').val() + ' ' + $('.js-form-input-7 textarea').val());
    });

    $(document).on('input change', '.js-form-input-5 input', function(){
        $('.js-form-input-5 input').val($(this).val());
    });

    $(document).on('click', '.js-form-next-step', function(e) {
        e.preventDefault();
        var inputCount = $('.js-form-part-1 input.wpcf7-validates-as-required').length;
        var validInputs = 0;

        $('.js-form-part-1 input.wpcf7-validates-as-required').each(function() {
            if ($(this).val() == '') {
                return false;
            } else {
                validInputs++;
            }
        });

        if(inputCount == validInputs) {
            $('.js-form-part-1').addClass('u-hidden');
            $('.js-form-part-2').removeClass('u-hidden');
        }
    });

    $(document).on('click', '.js-form-prev-step', function(e){
        e.preventDefault();
        $('.js-form-part-1').removeClass('u-hidden');
        $('.js-form-part-2').addClass('u-hidden');
    });
});

